import Loading, { LoadingBall } from "@ingka/loading";
import styles from "./LoadingSpinner.module.css";

interface LoadingSpinnerProps {
    message?: string;
}

export function LoadingSpinner({ message = "Loading..." }: LoadingSpinnerProps) {
    return (
        <div className={styles.container}>
            <Loading text={message}>
                <LoadingBall size="medium" color="emphasised" />
            </Loading>
        </div>
    );
}
